module.exports = __webpack_public_path__ + "media/images/emblems/Oberhof-blason-f8af2416ee81f1155096073977371e7a.png";